'use client';

import { useEffect } from 'react';

// Libraries
import LogRocket from 'logrocket';

// Components
import ErrorFallback from '@/components/ErrorFallback/ErrorFallback';
import LoginLayout from '@/layouts/LoginLayout/LoginLayout';

// Utils
import { logRocketException } from '@/utils/logrocket';

interface Props {
    error: Error;
    resetErrorBoundary: () => void;
}

export const GlobalErrorFallback = ( {
    error
    , resetErrorBoundary
}: Props ) => {
    useEffect( () => {
        try {
            LogRocket.captureException(
                logRocketException( error, 'Global Error Fallback' )
                , { tags: { component: 'Global Error Fallback' } }
            );
        } catch ( e ) {
            if ( e && e instanceof Error ) {
                LogRocket.captureException(
                    logRocketException( e, 'Global Error Fallback' )
                    , {
                        tags: {
                            component: 'Global Error Fallback'
                            , isCatch: true
                        }
                    }
                );
            }
        }
    }, [ error ] );

    return (
        <LoginLayout
            hideBackground
            showOperatorInfo={ false }
        >
            <ErrorFallback
                error={ error }
                resetErrorBoundary={ resetErrorBoundary }
            />
        </LoginLayout>
    );
};
